var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#FFF4EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0162 11.856C9.02661 11.7495 9.01267 11.6419 8.97547 11.542C8.93828 11.442 8.87887 11.3524 8.802 11.2802L7.2142 9.29663V9H12.1425L15.9522 17.6669L19.3012 9H24V9.29663L22.6426 10.645C22.585 10.6907 22.5406 10.7517 22.5142 10.8213C22.4877 10.891 22.48 10.9667 22.4921 11.0405V20.9578C22.48 21.0315 22.4877 21.1073 22.5142 21.1769C22.5406 21.2466 22.585 21.3075 22.6426 21.3533L23.9685 22.7025V23H17.3012V22.7034L18.6748 21.3209C18.8099 21.1809 18.8099 21.1397 18.8099 20.9262V12.9095L14.9917 22.9667H14.4766L10.0311 12.9095V19.6505C9.99455 19.9331 10.0855 20.2192 10.2776 20.424L12.0634 22.671V22.9667H7V22.671L8.785 20.424C8.87945 20.3225 8.94954 20.1998 8.98968 20.0655C9.02983 19.9312 9.03891 19.7891 9.0162 19.6505V11.856Z",
    fill: "#FF7A01"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.5f94e27ccf2aba52b10e2f2141a9d621.svg";
export { ForwardRef as ReactComponent };